module.exports = __webpack_public_path__ + "img/img_not_allowed_list.b6e9aba6.svg";